/* eslint-disable no-shadow */
import { appendParams } from '@utils/func'
import { API } from '@utils/axios'
import { IAPI } from 'AppTypes'

export class MediaAPI implements IAPI {
  prefix = '/Media'

  createPresignedUrl (params: TAnimeSubscriptionAPI.Params.CreatePresignedMedia) {
    const url = appendParams(`${this.prefix}/presignedUrl`, params)
    return API.put(url)
  }

  getPresignedUrl (params: TAnimeSubscriptionAPI.Params.GetPresignedMedia) {
    const url = appendParams(`${this.prefix}/presignedUrl`, params)
    return API.get(url)
  }

  uploadFileS3 (params: any) {
    return fetch(params.url, { method: 'PUT', body: params.data, headers: { 'Content-Type': params.fileType } })
  }

  async downloadFileS3 (url: string, params: any) {
    const response = await API.get(url, { params, responseType: 'blob' })
    return response
  }
}

export const mediaAPI = new MediaAPI()
